var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inbox-dropdown__timer"},[_c('span',{staticClass:"display"},[_vm._v(_vm._s(_vm.timer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }